export const Cta1 = () => (
  <>
    <div className='fixed inset-x-0 bottom-0 z-10 flex md:hidden'>
      <a
        href='/lp/system3/?argument=bzcUT99h&dmai=a67e36250d4bf8'
        className='mx-auto mb-5 flex h-[60px] rounded-full bg-[#f87300] text-center text-white transition-opacity hover:opacity-75'
      >
        <div className='flex flex-col justify-center pl-10 pr-2'>
          <div className='text-sm leading-snug'>＼条件ピッタリの／</div>
          <div className='text-lg font-bold leading-tight'>
            発注先を探してもらう
          </div>
        </div>
        <div className='flex h-[60px] w-[60px] items-center justify-center rounded-full bg-[#ff9623] text-xl font-bold'>
          無料
        </div>
      </a>
    </div>
    <div className='mt-8 h-[60px] md:hidden' />
  </>
);
